<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      boardSlug: "",
    };
  },
  // computed: {
  //   boardSlug() {
  //     return this.$route.params.boardSlug;
  //   },
  // },
  created() {
    this.boardSlug = this.$route.params.boardSlug;
  },
  mounted() {
    this.boardSlug = this.$route.params.boardSlug;
    this.addToBoard();
  },
  methods: {
    redirectToDashboard() {
      window.location.href = "/user/dashboard";
    },
    addToBoard() {
      this.$vs.loading();
      if (!this.boardSlug) {
        this.redirectToDashboard();
      } else {
        window.location.href = `https://api.getboarded.tech/oauth?addToBoard=${this.boardSlug}`;
      }
    },
  },
};
</script>

<style scoped></style>
